/* =============================================================================
   SuperTots - Buy X Get 1 Free (auto-add $0 gift + in-cart size/colour picker)
   [bot-built v2 - separate $0 gift product + variant picker, KeraFiber-style]
   Reads config from #BogoConfig (sections/bogo-free-gift.liquid).
   - Auto-adds the $0 gift's default variant when >= requiredQty qualifying items
     are in the cart; removes it otherwise.
   - The gift is a real $0-priced product variant, so it shows $0.00 in cart
     natively - no discount involved.
   - A <select name="bogo_gift_variant"> rendered by Liquid on the $0 gift line
     lets the customer choose the size/colour; on change we swap the line to the
     chosen $0 variant (remove + re-add) keeping the _free_gift property.
   - Guards against direct-add abuse: any line of the gift PRODUCT (or carrying
     the _free_gift property) is removed unless the buy-X condition is met.
   ============================================================================= */
(function () {
  'use strict';

  var cfgEl = document.getElementById('BogoConfig');
  if (!cfgEl) return;
  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  var params = new URLSearchParams(window.location.search);
  var previewOn = CFG.previewToken && params.get(CFG.previewToken) === '1';
  var active = CFG.enabled === true || previewOn;
  if (!active) return;
  if (!CFG.freeVariantId) return;

  var PRODUCT_IDS = String(CFG.productIds || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
  var VARIANT_IDS = String(CFG.variantIds || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
  var REQUIRED = parseInt(CFG.requiredQty, 10) || 2;
  var FREE_ID = String(CFG.freeVariantId);
  var FREE_PRODUCT_ID = String(CFG.freeProductId || '');
  var busy = false;

  function isQualifying(item) {
    if (item.properties && item.properties._free_gift) return false;
    if (FREE_PRODUCT_ID && String(item.product_id) === FREE_PRODUCT_ID) return false;
    if (PRODUCT_IDS.length) return PRODUCT_IDS.indexOf(String(item.product_id)) !== -1;
    if (VARIANT_IDS.length) return VARIANT_IDS.indexOf(String(item.variant_id)) !== -1;
    return false;
  }

  // A cart line is "the gift" if it carries our property OR belongs to the gift product.
  function isGiftLine(item) {
    if (item.properties && item.properties._free_gift) return true;
    if (FREE_PRODUCT_ID && String(item.product_id) === FREE_PRODUCT_ID) return true;
    return false;
  }

  function getCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }

  function sectionsToRequest() {
    var candidates = ['cart-drawer', 'cart-icon-bubble', 'main-cart-items', 'main-cart-footer', 'cart-live-region-text'];
    var present = [];
    candidates.forEach(function (id) {
      if (document.getElementById(id) || document.querySelector('#' + id) || document.querySelector(id)) present.push(id);
    });
    return present;
  }

  function applySections(sections) {
    if (!sections) return;
    var map = {
      'cart-icon-bubble': '#cart-icon-bubble',
      'cart-drawer': 'cart-drawer',
      'main-cart-items': '#main-cart-items',
      'main-cart-footer': '#main-cart-footer',
      'cart-live-region-text': '#cart-live-region-text'
    };
    Object.keys(sections).forEach(function (id) {
      var sel = map[id];
      var html = sections[id];
      if (!sel || !html) return;
      var dest = document.querySelector(sel);
      if (!dest) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var src = doc.querySelector(sel) || doc.getElementById(id);
      if (src) { dest.innerHTML = src.innerHTML; }
    });
  }

  function changeLine(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty, sections: sectionsToRequest() })
    }).then(function (r) { return r.json(); }).then(function (res) { applySections(res.sections); return res; });
  }

  function addVariant(variantId) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [{ id: parseInt(variantId, 10), quantity: 1, properties: { _free_gift: 'true' } }],
        sections: sectionsToRequest()
      })
    }).then(function (r) { return r.json(); }).then(function (res) { if (res && res.sections) applySections(res.sections); return res; });
  }

  function reconcile() {
    if (busy) return Promise.resolve();
    busy = true;
    return getCart().then(function (cart) {
      var qty = 0, gift = null, extraGifts = [];
      (cart.items || []).forEach(function (it) {
        if (isQualifying(it)) qty += it.quantity;
        if (isGiftLine(it)) { if (!gift) { gift = it; } else { extraGifts.push(it); } }
      });
      var shouldHave = qty >= REQUIRED;
      if (extraGifts.length) return changeLine(extraGifts[0].key, 0);
      if (shouldHave && !gift) return addVariant(FREE_ID);
      if (!shouldHave && gift) return changeLine(gift.key, 0);
      if (shouldHave && gift && gift.quantity !== 1) return changeLine(gift.key, 1);
      return null;
    }).catch(function (e) { if (window.console) console.warn('[BOGO]', e); })
      .then(function () { busy = false; });
  }

  // ---- Variant picker: swap the gift line to the chosen $0 variant ----
  function swapGift(newVariantId) {
    if (busy) return Promise.resolve();
    if (!newVariantId) return Promise.resolve();
    busy = true;
    return getCart().then(function (cart) {
      var gift = (cart.items || []).filter(isGiftLine)[0];
      if (!gift) { busy = false; return; }
      if (String(gift.variant_id) === String(newVariantId)) { busy = false; return; }
      return changeLine(gift.key, 0).then(function () {
        return addVariant(newVariantId);
      }).then(function () { busy = false; });
    }).catch(function (e) { if (window.console) console.warn('[BOGO swap]', e); busy = false; });
  }

  // delegated change listener - the <select> is re-rendered on every cart update.
  // Capture phase + stopPropagation: Dawn's CartItems (assets/cart.js) attaches a
  // bubble-phase 'change' listener on the ancestor <cart-drawer-items> that treats
  // every change event as a quantity-input change (reads dataset.min/max/step).
  // Without this the event bubbled into that handler, which computed step=NaN and
  // called reportValidity() with the literal "...increments of undefined" text.
  document.addEventListener('change', function (e) {
    var el = e.target;
    if (el && el.matches && el.matches('select[name="bogo_gift_variant"]')) {
      e.stopPropagation();
      swapGift(el.value);
    }
  }, true);

  // re-run reconcile after any cart mutation
  var origFetch = window.fetch;
  window.fetch = function () {
    var url = (arguments[0] && arguments[0].url) || arguments[0] || '';
    var p = origFetch.apply(this, arguments);
    if (typeof url === 'string' && /\/cart\/(add|change|update|clear)(\.js)?/.test(url)) {
      p.then(function () { if (!busy) setTimeout(reconcile, 80); }).catch(function () {});
    }
    return p;
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(reconcile, 250); });
  } else {
    setTimeout(reconcile, 250);
  }
})();
